export default __webpack_public_path__ + "static/media/p8.844514f3.jpg";